import { render, staticRenderFns } from "./FaPreFooter.vue?vue&type=template&id=77a13b65&scoped=true&"
import script from "./FaPreFooter.vue?vue&type=script&lang=js&"
export * from "./FaPreFooter.vue?vue&type=script&lang=js&"
import style0 from "./FaPreFooter.vue?vue&type=style&index=0&id=77a13b65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a13b65",
  null
  
)

export default component.exports